import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl, useDebounceOptionType } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { OptionType, useLayout } from '../../core'

import { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Select from 'react-select'
import { CompanyListTransformedResp, getCompaniesList } from './api'

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'

const Navbar = () => {
  const {
    company,
    setCompany,
    financialYear,
    setFinancialYear,
    trigger,
    companyOptions,
    setCompanyOptions,
    setFyStartDate,
    setFyEndDate,
  } = useLayout()
  // console.log(companyOptions)
  const [companyYearObj, setCompanyYearObj] = useState<CompanyListTransformedResp>()
  const debouncedCompany = useDebounceOptionType(company, 200)
  // const [companyOptions, setCompanyOptions] = useState<OptionType[]>([])
  const [yearOptions, setYearOptions] = useState<OptionType[]>([])

  const getCompanyList = useCallback(async () => {
    try {
      // setCompany({
      //   label: '',
      //   value: '',
      // })
      const res: any = await getCompaniesList()
      // console.log(res)
      if (!res) {
        throw new Error('Something Went wrong, Please Try Again')
      }
      if ('status' in res) {
        throw new Error(res.message)
      }

      setCompanyYearObj(res)

      const companies = Object.keys(res).map((cin) => ({
        label: res[cin].companyName,
        value: cin,
      }))
      // console.log(companyOptions.length)
      // console.log(companies.length)
      if (!companyOptions.length && companies.length > 0) {
        // console.log('setCompanyOptions -> companies')
        // console.log(companies)
        setCompanyOptions(companies)

        // Only set default company if there's no existing selection
        if (!company.value) {
          // console.log('setCompany -> companieslength -1')
          // If no valid saved company, set the first company as default
          // setCompany(companies[0])
          setCompany(companies[companies.length - 1])
        }
      } else if (companyOptions.length > 0 && companies.length > companyOptions.length) {
        // console.log('this elseif ran')
        setCompany(companies[companyOptions.length - 1])
      } else {
        // console.log('company set to none')
        setCompany({
          label: '',
          value: '',
        })
      }
    } catch (error: any) {
      // localStorage.clear()
      // localStorage.removeItem('fyEndDate')
      // localStorage.removeItem('fyStartDate')
      // localStorage.removeItem('financialYear')
      // localStorage.removeItem('company')

      setCompany({
        label: '',
        value: '',
      })
      setFinancialYear({label: '', value: ''})
      setFyStartDate('')
      setFyEndDate('')
      toast.error(error.message || 'An unexpected error occurred', {})
    }
  }, [])

  useEffect(() => {
    if (trigger) getCompanyList()
  }, [trigger])

  // useEffect(() => {
  //   if (debouncedCompany && debouncedCompany?.value) {
  //     const years = companyYearObj?.[debouncedCompany && debouncedCompany?.value]?.fyList.map(
  //       (yr) => ({
  //         label: yr,
  //         value: yr,
  //       })
  //     )
  //     years && setYearOptions(() => years)
  //     years && setFinancialYear(() => years[0])
  //   } else {
  //     setFinancialYear({
  //       value: '',
  //       label: '',
  //     })
  //   }
  // }, [debouncedCompany, companyYearObj, setFinancialYear])

  // Add dependencies to your useEffect where you set the financial year
  useEffect(() => {
    if (debouncedCompany && debouncedCompany?.value) {
      // console.log('debounced Company')
      // console.log(debouncedCompany)
      // console.log(companyYearObj)
      const years = companyYearObj?.[debouncedCompany.value]?.fyList.map((yr) => ({
        label: yr,
        value: yr,
      }))
      // console.log(years)
      if (years?.length) {
        setYearOptions(years)
        // Clear previous financial year before setting new one
        setFinancialYear({
          value: '',
          label: '',
        })
        // Set new financial year
        setFinancialYear(years[0])
      }
    } else {
      // console.log('else financial year block')
      setFinancialYear({
        value: '',
        label: '',
      })
    }
  }, [debouncedCompany, companyYearObj, setFinancialYear, trigger]) // Added trigger dependency

  const debouncedFinancialYear = useDebounceOptionType(financialYear, 150)

  useEffect(() => {
    if (
      companyYearObj &&
      debouncedCompany?.value &&
      companyYearObj[debouncedCompany.value]?.fyDetails &&
      debouncedFinancialYear?.value
    ) {
      try {
        const fyDetails =
          companyYearObj[debouncedCompany.value].fyDetails[debouncedFinancialYear.value]
        if (fyDetails) {
          setFyStartDate(fyDetails.startDate)
          setFyEndDate(fyDetails.endDate)
        }
      } catch (error) {
        console.error('Error setting fiscal year dates:', error)
      }
    }
  }, [companyYearObj, debouncedFinancialYear, debouncedCompany, trigger]) // Added trigger dependency

  // useEffect(() => {
  //   if (
  //     companyYearObj &&
  //     debouncedFinancialYear &&
  //     debouncedFinancialYear.value &&
  //     debouncedCompany &&
  //     debouncedCompany.value
  //   ) {
  //     console.log(companyYearObj)
  //     console.log(debouncedCompany.value)
  //     console.log(debouncedFinancialYear.value)
  //     setFyStartDate(
  //       companyYearObj[debouncedCompany.value].fyDetails[debouncedFinancialYear.value].startDate
  //     )
  //     setFyEndDate(
  //       companyYearObj[debouncedCompany.value].fyDetails[debouncedFinancialYear.value].endDate
  //     )
  //   }
  // }, [companyYearObj, debouncedFinancialYear, debouncedCompany])

  // Handle company change - clear selection first to avoid old value being used
  const handleCompanyChange = (option: OptionType | null) => {
    // console.log(company)
    // console.log(option)
    if (company.value === option?.value) return
    // First reset the financial year to avoid using the old value
    setFinancialYear({
      value: '',
      label: '',
    })

    // Then set the new company
    setCompany(() => option as OptionType)
  }

return (
  <div className='app-navbar'>
    <div className='app-navbar-item navbar-select-wrapper company-select-wrapper'>
      <div className='navbar-icon-prefix'>
        <KTIcon iconName='briefcase' className='fs-2' />
      </div>
      <Select
        value={company}
        isDisabled={!company?.value}
        onChange={handleCompanyChange}
        options={companyOptions}
        isSearchable={true}
        styles={{
          container: (base) => ({...base, flexGrow: 1}),
          control: (base) => ({...base, marginLeft: '2px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0}),
          valueContainer: (base) => ({...base, flex: 1}),
        }}
        components={{IndicatorSeparator: () => null}}
      />
    </div>

    <div className='app-navbar-item navbar-select-wrapper fy-select-wrapper'>
      <div className='navbar-icon-prefix'>
        <i className='fa-solid fa-calendar-days' />
      </div>
      <Select
        value={financialYear}
        onChange={(option) => setFinancialYear(option as OptionType)}
        isDisabled={!company?.value}
        options={yearOptions}
        isSearchable={false}
        styles={{
          container: (base) => ({...base, flexGrow: 1}),
          control: (base) => ({...base, marginLeft: '2px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0}),
          valueContainer: (base) => ({...base, flex: 1}),
        }}
        components={{IndicatorSeparator: () => null}}
      />
    </div>

    <div className={clsx('app-navbar-item', itemClass)}>
      <div
        className={clsx('cursor-pointer symbol', userAvatarClass)}
        data-kt-menu-trigger="{default: 'click'}"
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <img src={toAbsoluteUrl('/media/avatars/Default.jpg')} alt='' />
      </div>
      <HeaderUserMenu />
    </div>
  </div>
)
}

export { Navbar }

